import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { routerTransition } from '../../../shared/animations/router.animations';
import { readWrite } from '../../../user/user-permission/user-permission.data';
import { UserPermissionService } from '../../../user/user-permission/user-permission.service';
import { Tenant } from '../tenant.model';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'ifb-tenant-list',
    templateUrl: './tenant-list.component.html',
    styleUrls: ['./tenant-list.component.scss'],
    animations: routerTransition,
    standalone: false
})
export class TenantListComponent implements OnInit, AfterViewInit {

  constructor(
    private route: ActivatedRoute,
    private userPermissionService: UserPermissionService) { }

  data: TenantListComponentData;
  readWriteTenant: boolean;
  dataSource = new MatTableDataSource<Tenant>();

  ngOnInit() {
    this.route.data.pipe(untilDestroyed(this))
      .subscribe((it: TenantListComponentData) => {
        this.data = it;
        if (this.data)
          this.dataSource = new MatTableDataSource(this.data.tenantListResult);
      });

    this.userPermissionService.granted([readWrite('admin-tenants')])
      .pipe(untilDestroyed(this))
      .subscribe(res => this.readWriteTenant = res);
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  @ViewChild(MatPaginator, { static: true })
  paginator: MatPaginator;

  tableColumns: string[] = [
    'overridden',
    'name',
    'dba',
    'phone',
    'email',
    'url',
    'address',
    'actions'
  ];

}

export interface TenantListComponentData {
  tenantListResult: Tenant[];
}
